<cc-box>
  <div class="text-wrapper lg-container" box header>{{'LEAD_GENERATION.CREATOR.BUBBLE.TEXT' | translate }}</div>
  <div box content>
    <cc-lg-label-input icon="title" label="{{'LEAD_GENERATION.CREATOR.BUBBLE.TITLE' | translate }}"
                    [control]="popupSettings.controls.title"></cc-lg-label-input>
<!--    <cc-lg-label-input [textarea]="true" icon="description" label="{{'LEAD_GENERATION.CREATOR.BUBBLE.DESCRIPTION' | translate }}"-->
<!--                    [control]="popupSettings.controls.description"></cc-lg-label-input>-->
<!--    <cc-lg-label-input icon="input-img" label="{{'LEAD_GENERATION.CREATOR.BUBBLE.INPUT' | translate  }}"-->
<!--                    [control]="popupSettings.controls.phoneNumberLabel"></cc-lg-label-input>-->
    <cc-lg-label-input icon="button" label="{{'LEAD_GENERATION.CREATOR.BUBBLE.BUTTON' | translate }}"
                    [control]="popupSettings.controls.submitButtonTextBig"></cc-lg-label-input>
<!--    <cc-lg-label-input icon="thanks" label="{{'LEAD_GENERATION.CREATOR.BUBBLE.THANK_YOU_MESSAGE' | translate  }}"-->
<!--                    [control]="popupSettings.controls.thanksTitle"></cc-lg-label-input>-->
    <cc-lg-label-input label="{{'LEAD_GENERATION.CREATOR.BUBBLE.CALL_US' | translate }}"
                    [control]="popupSettings.controls.callUsText"></cc-lg-label-input>

    <cc-lg-label-input label="{{'LEAD_GENERATION.CREATOR.BUBBLE.HANGUP' | translate }}"
                       [control]="popupSettings.controls.hangupButtonText"></cc-lg-label-input>
  </div>
</cc-box>
